<template>
  <div class="list">
		
    <productdetail
      v-for="_id in idList"
      v-show="_id == ineer_id"
      :id="ineer_id"
      :params="params"
      :key="_id"
    />
		
  </div>
</template>


<script>
  import productpageJs from './productpage.js'
  export default productpageJs
</script>
<style>



</style>



// WEBPACK FOOTER //
// src/views/detail/productpage.vue